import './styles.scss';

import * as React from 'react';
import { Sidenav } from './Sidenav';
import GeneralInformaionContainer from '../../containers/venue-management/GeneralInformation';
import { TwsAdmin, ActiveItem } from './types';
import { LoadingSpinner } from '@weddingspot/ws-core-components';
import { HBToastContainer, hbToastSuccess, hbToastInfo, hbToastWarn, hbToastError, hbToast } from '../toast';
import { StickyContainer, Sticky } from 'react-sticky';
import AvailabilityContainer from '../../containers/venue-management/Availability';
import AmenitiesContainer from '../../containers/venue-management/Amenities';

interface OwnProps {
    activeItem: ActiveItem;
    navigateTo: (item: ActiveItem) => void;
    setTouched: (touched: boolean) => void;

    /* Venue-related props */
    loadingVenuesData: boolean;
    availableVenues: TwsAdmin.AvailableVenue[] | null;
    currentVenue: TwsAdmin.AvailableVenue | null;
    onCreateNewVenue: (id: number, name: string) => void;
}

export class VenueManagement extends React.Component<OwnProps, {}> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        return (
            <div className='VenueManagement'>
                <StickyContainer>
                    <Sticky>
                        {({ style }) => (
                            <div
                                style={{
                                    ...style,
                                    zIndex: 90, // below modals, above other content
                                }}
                            >
                                <HBToastContainer showCloseButton={true} />
                            </div>
                        )}
                    </Sticky>
                    <div className='VenueManagement--content-container'>
                        <div className='VenueManagement--header'>
                            {this.props.loadingVenuesData && 'Loading...'}
                            {!this.props.loadingVenuesData &&
                                (!!this.props.currentVenue ? `Edit venue: ${this.props.currentVenue.venue_name}` : `Create new venue`)}
                        </div>
                        {/* Uncomment this when we're ready to have a venue selector
                    
                    <div className="VenueManagement--venue-selector-container">
                        {(!this.props.loadingVenuesData &&
                            !!this.props.availableVenues &&
                            this.props.availableVenues.length > 0
                        ) && (
                            <Dropdown>
                                {(togglerRef, contentRef, isOpen) => (
                                    <div>
                                        <a
                                            href="#"
                                            className="VenueManagement--venue-selector"
                                            ref={togglerRef}
                                        >
                                            Switch Venue &#9660;
                                        </a>
                                        <div
                                            className={cls(
                                                'VenueManagement--venue-selector-menu',
                                                {'VenueManagement--venue-selector-menu__open': isOpen}
                                            )}
                                        >
                                            {this.renderVenueSelector()}
                                        </div>
                                    </div>
                                )}
                            </Dropdown>
                        )}
                    </div>
                    */}
                        <div className='VenueManagement--divider' />
                        <div className='VenueManagement--body'>
                            <div className='VenueManagement--sidenav-container'>
                                <Sidenav
                                    isCreateNewVenue={!this.props.currentVenue}
                                    currentVenueId={!!this.props.currentVenue ? this.props.currentVenue.venue_id : undefined}
                                    activeItem={this.props.activeItem}
                                    navigate={this.props.navigateTo}
                                />
                            </div>
                            <div className='VenueManagement--right-content-container'>{this.renderItemContent(this.props.activeItem)}</div>
                        </div>
                    </div>
                </StickyContainer>
            </div>
        );
    }

    private renderItemContent(activeItem: ActiveItem) {
        switch (activeItem) {
            case ActiveItem.GENERAL:
                return this.renderGeneral();
            case ActiveItem.AVAILABILITY:
                return this.renderAvailability();
            case ActiveItem.AMENITIES:
                return this.renderAmenities();
            default:
                return <div>NO CONTENT</div>;
        }
    }

    private renderGeneral() {
        if (this.props.loadingVenuesData) {
            return (
                <div className='VenueManagement--right-container-loading'>
                    <LoadingSpinner />
                </div>
            );
        }

        return (
            <GeneralInformaionContainer
                loadingVenueData={this.props.loadingVenuesData}
                onCreateNewVenue={this.props.onCreateNewVenue}
                currentVenue={this.props.currentVenue}
                onFormError={() => this.showErrorToast()}
                onFormSuccess={() => this.showSuccessToast()}
                onInitError={() => this.showInitErrorToast()}
                setTouched={this.props.setTouched}
            />
        );
    }

    private renderAvailability() {
        // This generally won't be called without a valid currentVenue, but
        // if it does, just render nothing
        if (!this.props.currentVenue) {
            return <div />;
        }

        if (this.props.loadingVenuesData) {
            return (
                <div className='VenueManagement--right-container-loading'>
                    <LoadingSpinner />
                </div>
            );
        }

        return (
            <AvailabilityContainer
                currentVenue={this.props.currentVenue}
                onFormError={() => this.showErrorToast()}
                onFormSuccess={() => this.showSuccessToast()}
                onInitError={() => this.showInitErrorToast()}
                setTouched={this.props.setTouched}
            />
        );
    }

    private renderAmenities() {
        // This generally won't be called without a valid currentVenue, but
        // if it does, just render nothing
        if (!this.props.currentVenue) {
            return <div />;
        }

        if (this.props.loadingVenuesData) {
            return (
                <div className='VenueManagement--right-container-loading'>
                    <LoadingSpinner />
                </div>
            );
        }

        return (
            <AmenitiesContainer
                currentVenue={this.props.currentVenue}
                onFormError={() => this.showErrorToast()}
                onFormSuccess={() => this.showSuccessToast()}
                onInitError={() => this.showInitErrorToast()}
                setTouched={this.props.setTouched}
            />
        );
    }

    private renderVenueSelector() {
        if (this.props.loadingVenuesData) {
            return null;
        }

        // Should be loaded by the time loadingVenuesData = True
        let venuesList = this.props.availableVenues || [];
        let { currentVenue } = this.props;
        venuesList = venuesList.filter((item) => {
            if (currentVenue === null) {
                return true;
            }

            return item.venue_id !== currentVenue.venue_id;
        });

        return venuesList.map((item, idx) => {
            return (
                <div key={idx} className=''>
                    {item.venue_name}
                </div>
            );
        });
    }

    private showErrorToast() {
        hbToastError(
            <div className='VenueManagement--toast VenueManagement--toast__error'>
                <div className='VenueManagement--toast--icon VenueManagement--toast--icon__error'>
                    <i className='icon-hb-nx-exclamation-mark-circle-16' />
                </div>
                <div className='VenueManagement--toast--text'>
                    <div className='VenueManagement--toast--header'>Changes to venue not saved</div>
                    <div className='VenueManagement--toast--subheader'>Please review and correct any errors to continue.</div>
                </div>
            </div>
        );
    }

    private showSuccessToast() {
        hbToastSuccess(
            <div className='VenueManagement--toast'>
                <div className='VenueManagement--toast--icon VenueManagement--toast--icon__success'>
                    <i className='icon-hb-nx-check-circle' />
                </div>
                <div className='VenueManagement--toast--text'>Venue information successfully saved</div>
            </div>
        );
    }

    private showInitErrorToast() {
        hbToastError(
            <div className='VenueManagement--toast VenueManagement--toast__error'>
                <div className='VenueManagement--toast--icon VenueManagement--toast--icon__error'>
                    <i className='icon-hb-nx-exclamation-mark-circle-16' />
                </div>
                <div className='VenueManagement--toast--text'>
                    <div className='VenueManagement--toast--header'>Failed to initialize form</div>
                    <div className='VenueManagement--toast--subheader'>
                        Some data could not be downloaded from server. Please refresh the page to try again.
                    </div>
                </div>
            </div>
        );
    }
}
